<template>
    <v-dialog v-model="dialog" max-width="300" transition="dialog-bottom-transition" @keydown.enter="save" @keydown.esc="cancel">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark :disabled="loading" @click="cancel">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-toolbar-title>Notes</v-toolbar-title>
            </v-toolbar>
            <v-layout column>
                <v-list>
                    <v-list-tile v-for="(item, i) in $Constants.HARVESTPLAN_NOTICATIONS" :key="i">
                        <v-list-tile-content>
                            <v-checkbox :label="item.ID" v-model="selected[item.ID]"></v-checkbox>                            
                        </v-list-tile-content>
                        <v-list-tile-avatar>
                            <v-avatar :class="`${item.Color} ml-2 mb-1 mr-2`" size="16"></v-avatar>
                        </v-list-tile-avatar>                
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-checkbox label="Apply to all rows in this location" v-model="applyToAll"></v-checkbox>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-layout>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="save" :loading="loading" color="primary" :disabled="loading || !editable">Save</v-btn>
                <v-btn @click="cancel" :disabled="loading" color="error">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        notes: {
            type: String,
            required: false
        },
        editable: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {     
            dialog: true,       
            loading: false,
            applyToAll: true,
            selected: {}
        }
    },
    watch: {
        dialog(val) {
            if (!val) {
                this.$emit("cancel");
            }
        }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        save() {
            let result = this.$Constants.HARVESTPLAN_NOTICATIONS.filter(n => this.selected[n.ID]).map(n => { return n.ID }).join(",");

            this.$emit("save", { notes: result == "" ? null : result, applyToAll: this.applyToAll });
        },
    },
    created() {
        this.$Constants.HARVESTPLAN_NOTICATIONS.forEach(element => {
            this.selected[element.ID] = false;
        });

        if (this.notes) {
            this.notes.split(",").forEach(note => {                
                this.selected[note.trim()] = true;
            })
        }
    }
}
</script>
